"use client";

import * as React from 'react';
import cls from './textArea.module.css';
import { cn } from '@/lib/utils';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  size?: 'sm' | 'md' | 'lg';
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, invalid = false, size = 'md', resize, ...rest }, ref) => {
    const textClass = size === 'sm' ? 'body-sm' : size === 'lg' ? 'body-lg' : 'body-md'
    const resizeClass =
      resize === 'none'
        ? cls['resize-none']
        : resize === 'vertical'
        ? cls['resize-vertical']
        : resize === 'horizontal'
        ? cls['resize-horizontal']
        : resize === 'both'
        ? cls['resize-both']
        : undefined;

    return (
      <textarea
        ref={ref}
        className={cn(
          textClass,
          cls.textarea,
          size === 'sm' && cls['size-sm'],
          size === 'md' && cls['size-md'],
          size === 'lg' && cls['size-lg'],
          resizeClass,
          invalid && cls.invalid,
          className,
        )}
        {...rest}
      />
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;


